module.exports = __webpack_public_path__ + "media/application/images/svgs/align-justify-8a6277b097ecd89621b826ba641b3dca.svg";